import { useLocation } from '@tanstack/react-router'

import { sendFeedback } from '@/features/feedback/api'
import { FeedbackButton } from '@/features/feedback/form'
import type { AuthState } from '@/lib/auth-store'
import { useT } from '@/lib/i18n/translate'

interface Target {
  id: string
  name: string
}

/**
 * The landing-page buttons (I3): Romi alone on the root page; Romi plus the
 * restaurant or branch on theirs. Logged-in users only — anonymous feedback
 * without an order is a spam endpoint.
 */
export function LandingFeedbackButtons({ auth, restaurant, branch }: { auth: AuthState<'restaurant'>; restaurant?: Target; branch?: Target }) {
  const t = useT()
  const location = useLocation()
  if (auth.status !== 'authenticated') return null
  const none = { restaurant_id: null, branch_id: null, order_id: null, path: null }
  return (
    <div className="flex flex-wrap gap-3">
      {restaurant && (
        <FeedbackButton
          label={t('feedback.for', { name: branch?.name ?? restaurant.name })}
          send={(message) => sendFeedback({ ...none, target: 'restaurant', restaurant_id: restaurant.id, branch_id: branch?.id ?? null, message })}
        />
      )}
      <FeedbackButton label={t('feedback.forRomi')} send={(message) => sendFeedback({ ...none, target: 'app', message, path: location.pathname })} />
    </div>
  )
}
